import { Suspense, useContext, useEffect, useState } from "react";
import { Route, Router, Switch, useHistory } from "react-router-dom";
import { Menu } from "../components/Menu";
import { AppRoutes } from "./Routes";
import { DynamicModulesContext } from "../contexts/DynamicModuleProvider";
import LoadComponent from "../core/loadComponent";
import { DrawerItem } from "components/Drawer/DrawerMenu";
import Footer from "../components/Footer"; 
import Loading from "../components/Loading";
import * as Pages from "../pages";
import { Container } from "@grupoboticario/flora-react";

export default function Routes() {
  const history = useHistory();
  const [menuLeft, setMenuLeft] = useState<Array<DrawerItem>>([]);
  const dynamicModulesContext = useContext(DynamicModulesContext);
  const router = [...AppRoutes];

  useEffect(() => {

    const menuItens: Array<DrawerItem> = [];

    dynamicModulesContext.map((menu: any) => {
      menuItens.push({
        icon: menu.icon,
        title: menu.name,
        path: menu.application?.route_prefix || "",
        external_link: !menu.application ? menu.external_link || "" : "",
      });
    });

    setMenuLeft(menuItens);
  }, [dynamicModulesContext]);

  return (
    <Suspense fallback={<Loading />}>
      <Menu items={menuLeft} />
      <Container style={{minHeight: "calc(100vh - 94px)",padding: 0}}>
      
        <Router history={history}>
          <Switch>
            {router.map((route) => {
              return (
                <Route
                  exact
                  key={route.path}
                  path={route.path}
                  component={route.component}
                />
              );
            })}
          
            {dynamicModulesContext.length > 0 &&
              dynamicModulesContext.map((route, index) => {
                if (!!route.application) {
                  return (
                    <Route path={route.application?.route_prefix} key={index}>
                      <LoadComponent scope={route} />
                    </Route>
                  );
                }
              })}

            <Route path="*" key={"notfound"} component={Pages.PageNotFound} />
          </Switch>
        </Router>
      </Container>
      <Footer />
    </Suspense>
  );
}
